<template>
  <v-app dark class="leaply app" v-if="!loading">
    <Navigation />

    <v-toolbar app absolute class="transparent elevation-0">
      <v-toolbar-side-icon
        v-if="loggedIn"
        @click.stop="$store.commit('toggleDrawer')"
      />
      <v-toolbar-title class="toolbar__title white--text">
        <Logo letters="white" dot="white" class="mt-2" />
      </v-toolbar-title>

      <v-spacer />
    </v-toolbar>

    <router-view :key="$route.fullPath" @signup="signup = true" />

    <v-snackbar bottom
      v-if="snackbar"
      :value="snackbar"
      :color="snackbar.type"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <v-btn small flat
        v-if="snackbar.button"
        v-text="snackbar.button.text"
        :to="snackbar.button.link"
      />
      <v-btn v-else small flat fab @click="$store.commit('snackbar', null)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-footer class="footer">
      <v-flex xs12 class="caption grey--text text-xs-center">
        &copy; {{ new Date().getFullYear() }} Leaply Corporation (Pty) Ltd. All rights reserved. Patent pending.
        <router-link to="/privacy_policy">
          Privacy Policy
        </router-link>
      </v-flex>
    </v-footer>
  </v-app>
</template>

<script>
// Components
import Logo from '@/components/Logo'
import Navigation from '@/components/Navigation'

// Helpers
import { mapGetters } from 'vuex'
import _ from 'lodash'

// Vue Component
export default {
  name: 'Leaply',

  components: { Logo, Navigation },

  created() {
    this.waitForAuthorization()
  },

  data() {
    return {
      loading: true,
      showLogin: false,
    }
  },

  computed: {
    ...mapGetters({
      loggedIn: 'auth/loggedIn',
      role: 'auth/role',
      fullName: 'auth/fullName',
      snackbar: 'snackbar',
    }),
  },

  methods: {
    waitForAuthorization() {
      if (!this.loggedIn || !!_.get(this, '$ability.rules.length')) return this.loading = false

      setTimeout(this.waitForAuthorization, 100)
    },
  },
}
</script>

<style lang="scss">
.v-toolbar--absolute > .v-toolbar__content {
  margin: auto;

  @media only screen and (min-width:  960px) { max-width:  900px; }
  @media only screen and (min-width: 1264px) { max-width: 1185px; }
  @media only screen and (min-width: 1904px) { max-width: 1785px; }
}
</style>
